document.addEventListener('click', function(e) {
  const btn = e.target.closest('.show-more-5-btn');
  if (!btn) return;
  btn.closest('.spf-product__swatchs').classList.add('show-more-5');
  btn.style.display = 'none';
});
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.pc-swatches__more');
  if (!btn) return;
  e.preventDefault();
  var fs = btn.closest('.pc-swatches');
  if (!fs) return;
  var expanded = fs.classList.toggle('is-expanded');
  btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
});
/* SPF: kolejność kart — shuffle / sort po variant ID (wybrane kolekcje) / brak przy sortowaniu klienta; z paginacją */
(function () {
  // >>> HANDLE kolekcji (z URL /collections/<handle>) sortowane po variant ID malejąco (najnowsze pierwsze) <<<
  var TARGET_COLLECTION_HANDLES = ['nowosci-damskie','new-merino-wool-arrivals','nowosci-meskie','mens-new-merino-wool-arrivals'];

  var defaultSort = null;
  function currentSort() { try { return globofilter.state.queryParams.sort_by || null; } catch (e) { return null; } }
  function capture() { if (defaultSort === null) { var s = currentSort(); if (s) defaultSort = s; } }

  function currentHandle() {
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function isTargetCollection() {
    var h = currentHandle();
    return h !== null && TARGET_COLLECTION_HANDLES.indexOf(h) !== -1;
  }
  function variantId(el) { var v = el.getAttribute('data-variant-id'); return v ? parseInt(v, 10) : 0; }

  function process() {
    capture();
    var cur = currentSort();
    var sorted = !!(cur && defaultSort && cur !== defaultSort);

    var items = document.querySelectorAll('[class*="spf-col"]');
    if (!items.length) return;

    // klient wybrał sortowanie → kolejność Globo
    if (sorted) { items.forEach(function (el) { el.style.removeProperty('order'); }); return; }

    // wybrane kolekcje → variant ID malejąco (ranking bezpieczny dla CSS order)
    if (isTargetCollection()) {
      var arr = Array.prototype.slice.call(items);
      arr.sort(function (a, b) { return variantId(b) - variantId(a); });
      arr.forEach(function (el, i) { el.style.order = i; });
      return;
    }

    // reszta → shuffle + sekwencyjne strony
    var page = 1;
    items.forEach(function (el) {
      var dp = el.getAttribute('data-page');
      if (dp) { var n = parseInt(dp, 10); if (!isNaN(n)) page = n; }
      if (el.dataset.pcOrder === undefined) { var base = parseInt(el.style.order, 10); el.dataset.pcOrder = isNaN(base) ? '0' : String(base); }
      el.style.order = (page * 1000000) + parseInt(el.dataset.pcOrder, 10);
    });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(process, 60); }
  if (document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();